import { render, staticRenderFns } from "./tipDialog.vue?vue&type=template&id=2c69be40&scoped=true&"
import script from "./tipDialog.vue?vue&type=script&lang=ts&"
export * from "./tipDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69be40",
  null
  
)

export default component.exports